import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './App.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
const rootNode = document.getElementById('root');

rootNode.childNodes.length === 0 && ReactDOM.hydrate(<App />, rootNode);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(console.log);
